"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _KeyValueTree = require("../abi/KeyValueTree.json");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

class KeyValueTree {
  constructor(FDSAccount, contractAddress) {
    this.account = FDSAccount;
    this.contractAddress = contractAddress;
    this.con = FDSAccount.getContract(_KeyValueTree.abi, contractAddress);
  }

  getSharedId() {
    var _arguments = arguments,
        _this = this;

    return _asyncToGenerator(function* () {
      var address = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
      return _this.con.call('getSharedId', []);
    })();
  }

  getRootId() {
    var _arguments2 = arguments,
        _this2 = this;

    return _asyncToGenerator(function* () {
      var address = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : false;
      return _this2.con.call('getRootId', []);
    })();
  }

  setKeyValue(nodeId, key, value) {
    var _this3 = this;

    return _asyncToGenerator(function* () {
      return _this3.con.send('setKeyValue', [nodeId, key, value], true);
    })();
  }

  getKeyValue(nodeId, key) {
    var _this4 = this;

    return _asyncToGenerator(function* () {
      return _this4.con.call('getValue', [nodeId, key]);
    })();
  }

  getKeyValues(nodeId) {
    var _this5 = this;

    return _asyncToGenerator(function* () {
      return _this5.con.call('getKeysValues', [nodeId]);
    })();
  }

  addChildNode(parentNodeId, newNodeId) {
    var _this6 = this;

    return _asyncToGenerator(function* () {
      return _this6.con.send('addChildNode', [parentNodeId, newNodeId]);
    })();
  }

  getChildren(parentNodeId) {
    var _this7 = this;

    return _asyncToGenerator(function* () {
      return _this7.con.call('getChildren', [parentNodeId]);
    })();
  }

}

var _default = KeyValueTree;
exports.default = _default;
module.exports = exports.default;